import request from '@/utils/request'

// crm 新建回款
export function crmReceivablesSave(data) {
  return request({
    url: 'crm/receivables/save',
    method: 'post',
    data: data
  })
}

// crm 回款編輯
export function crmReceivablesUpdate(data) {
  return request({
    url: 'crm/receivables/Update',
    method: 'post',
    data: data
  })
}

/**
 * 回款列表
 * @param {*} data
 * page 頁碼
 * limit 每頁數量
 * search 普通搜索
 */
export function crmReceivablesIndex(data) {
  return request({
    url: 'crm/receivables/index',
    method: 'post',
    data: data
  })
}

/**
 * 刪除
 * @param {*} data
 *
 */
export function crmReceivablesDelete(data) {
  return request({
    url: 'crm/receivables/delete',
    method: 'post',
    data: data
  })
}

/**
 * 回款詳情
 * @param {*} data
 */
export function crmReceivablesRead(data) {
  return request({
    url: 'crm/receivables/read',
    method: 'post',
    data: data
  })
}

/**
 * 回款計劃列表
 * @param {*} data
 * page 頁碼
 * limit 每頁數量
 * search 普通搜索
 */
export function crmReceivablesPlanIndex(data) {
  return request({
    url: 'crm/receivables_plan/index',
    method: 'post',
    data: data
  })
}

/**
 * 回款計劃刪除
 * @param {*} data
 */
export function crmReceivablesPlanDeleteAPI(data) {
  return request({
    url: 'crm/receivables_plan/delete',
    method: 'post',
    data: data
  })
}

/**
 * 回款審覈
 * @param {*} data
 */
export function crmReceivablesCheck(data) {
  return request({
    url: 'crm/receivables/check',
    method: 'post',
    data: data
  })
}

/**
 * 回款撤回審批
 * @param {*} data
 */
export function crmReceivablesRevokeCheck(data) {
  return request({
    url: 'crm/receivables/revokeCheck',
    method: 'post',
    data: data
  })
}

